import { MapsAPILoader } from '@agm/core';
import {
	Component,
	HostListener,
	Inject,
	OnInit,
	ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent, MatDateRangePicker } from '@angular/material/datepicker';
import {
	MAT_DIALOG_DATA,
	MatDialog,
	MatDialogRef,
} from '@angular/material/dialog';
import MarkerClusterer from '@google/markerclustererplus';
import { select, Store } from '@ngrx/store';
import { HeatmapLayer } from '@ngui/map';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Observable } from 'rxjs';
import {
	linesName,
	placeComplaint,
	placeComplaintDict,
	typeComplaintDict,
	typesComplaint,
} from '../../../assets/complaintsDetail/complaintsInfo';
import { ComplaintsService } from '../../core/services/complaints.service';
import { UserService } from '../../core/services/user.service';
import { Denounce } from './../../core/models/denounce.model';
import { SseService } from './../../core/services/sse.service';
import { UtilsService } from './../../core/services/utils.service';
import { AppState } from './../../core/state/app.reducer';
import * as fromComplaintsActions from './state/complaints.actions';
import * as fromComplaintsSelector from './state/complaints.selectors';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
	public displayedColumnsDenounces: string[] = [
		'id',
		'action',
		'date',
		'status',
	];

	typesComplaint: string[] = typesComplaint;
	typeComplaintDict = typeComplaintDict;
	placeComplaintDict = placeComplaintDict;
	placeComplaint = placeComplaint;
	linesName: string[] = linesName;
	sublocalities: string[] = [];
	created_at_from_date_complaint: any;
	created_at_to_date_complaint: any;
	user_id_complaint: any;

	public complaints$: Observable<Denounce[]>;
	public complaints: Array<Denounce>;
	public denounces: [Denounce?] = [];

	public currentYearDate = new Date();
	public currentYear = this.currentYearDate.getFullYear();
	public lastTwoWeeks: Date = null;
	public initialDate: Date = null;
	public lastWeek: Date | String = null;
	public endDate: Date = null;
	public barChartLabels = [`Todos os casos`];
	public selectedLabel = 'Todos';
	public elementsNavGraphs = [
		'Dados sobre importunação',
		'Etnografia',
		'Frequência',
	];
	public navGrapActive = 'Dadossobreimportunação';

	@ViewChild(MatDateRangePicker) dateRangePicker: MatDateRangePicker<Date>;

	searchFilter: FormGroup;

	public from: Date = null;
	public to: Date = null;

	casosMomentoOcorridos = 'carregando...';
	casosAposOcorridos = 'carregando...';
	ocorrenciasFiltradas = [];
	checkinPercentage = 0;

	public minDate: Date;
	public maxDate: Date;

	selectedOption = 'Todos';

	showFilters: boolean = false;
	setShowFilters(value: boolean) {
		this.showFilters = value;
	}

	cleanFilters() {
		this.showFilters = false;
		this.setDefaultValues();

		this.getComplaintsRecurrent();
	}

	closeModal(event: MouseEvent): void {
		if (event.target === event.currentTarget) {
			this.setShowFilters(false);
		}
	}

	public weekData: any = {};
	public dashboardCardsData: any = {};

	public completedPercent = null;
	public casesPercent = null;
	public imagePercent = null;

	public innerWidth: number;

	public rankings: any = {};

	loading = true;
	loading$: Observable<boolean>;

	fillerNav = Array.from({ length: 3 }, (_, i) => `Nav Item ${i + 1}`);
	mobileQuery: MediaQueryList;

	res: any;

	@ViewChild(HeatmapLayer) heatmapLayer: HeatmapLayer;

	public heatmap: google.maps.visualization.HeatmapLayer;

	public center = { lat: -3.71839, lng: -38.5434 };
	public map: google.maps.Map;
	public markers = [];
	sse$: Observable<Denounce[]>;

	@HostListener('window:resize', ['$event'])
	onResize(_event: any): any {
		this.innerWidth = window.innerWidth;
	}

	constructor(
		public dashService: ComplaintsService,
		public utilsService: UtilsService,
		public mapsAPILoader: MapsAPILoader,
		private userService: UserService,
		public store: Store<AppState>,
		public sse: SseService,
		public dialog: MatDialog
	) {
		this.innerWidth = window.innerWidth;
		this.complaints = [];
		this.minDate = new Date(2022, 4, 9);
		this.maxDate = new Date();
	}

	ngAfterViewInit(): void {
		this.activeNavGraph(null);
	}

	loadingCsv: boolean = false;

	getCsv(event_log = false) {
		this.loadingCsv = true;
		this.dashService.getCsv(event_log).subscribe(
			(res: any) => {
				this.loadingCsv = false;

				let csv = res;
				const hiddenElement = document.createElement('a');
				hiddenElement.target = '_blank';
				const timeNow = new Date();
				const time = timeNow.toISOString().split('T')[0];

				hiddenElement.href =
					'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csv);
				hiddenElement.target = '_blank';
				hiddenElement.download = this.from
					? `casos_from_${String(
							this.from.toISOString().split('T')[0]
					  )}_to_${String(this.to.toISOString().split('T')[0])}.csv`
					: `casos_${time}.csv`;
				hiddenElement.click();
				hiddenElement.remove();

				this.loadingCsv = false;
			},
			(err) => {
				this.loadingCsv = false;
			}
		);
	}

	getPdf() {
		const footerImg = 'assets/icons/purple-logo.svg';
		const imgPromise = this.loadImageAsDataUrl(footerImg);

		html2canvas(document.querySelector('#relatory-page-1'), {
			scrollY: -window.scrollY,
		}).then((canvas) => {
			const pdf = new jsPDF('p', 'mm', 'a4');
			const pdfWidth = pdf.internal.pageSize.getWidth();
			const pdfHeight = pdf.internal.pageSize.getHeight();

			imgPromise.then((footerImgData) => {
				const imgWidth = canvas.width;
				const imgHeight = canvas.height;
				let yPos = 0;
				let heightLeft = imgHeight;

				const pageContentHeightPixels = 2350;

				const addFooter = (pdf, yPos) => {
					const footerText = 'Cidades seguras para todos.';
					pdf.setFontSize(10);
					const textWidth =
						(pdf.getStringUnitWidth(footerText) * pdf.internal.getFontSize()) /
						pdf.internal.scaleFactor;
					const footerImgWidth = 20;
					const footerImgHeight = 10;

					pdf.text(
						footerText,
						pdfWidth - textWidth - footerImgWidth - 15,
						pdfHeight - footerImgHeight / 2 - 10
					);

					pdf.addImage(
						footerImgData,
						'PNG',
						pdfWidth - footerImgWidth - 10,
						pdfHeight - footerImgHeight - 10,
						footerImgWidth,
						footerImgHeight
					);
				};

				const sliceAndAddPages = () => {
					let pageCounter = 0;
					while (heightLeft > 0) {
						let sliceHeight =
							heightLeft < pageContentHeightPixels
								? heightLeft
								: pageContentHeightPixels;

						const canvasSlice = document.createElement('canvas');
						canvasSlice.width = imgWidth;
						canvasSlice.height = sliceHeight;
						const ctx = canvasSlice.getContext('2d');
						ctx.drawImage(
							canvas,
							0,
							yPos,
							imgWidth,
							sliceHeight,
							0,
							0,
							imgWidth,
							sliceHeight
						);

						const imgData = canvasSlice.toDataURL('image/png');
						pdf.addImage(
							imgData,
							'PNG',
							0,
							pageCounter === 1 ? 20 : 0,
							pdfWidth,
							(sliceHeight * pdfWidth) / imgWidth
						);

						addFooter(pdf, pdfHeight);

						heightLeft -= sliceHeight;
						yPos += sliceHeight;

						if (heightLeft > 0) {
							pdf.addPage();
						}
						pageCounter++;
					}
				};

				sliceAndAddPages();
				pdf.save('download.pdf');
			});
		});
	}

	loadImageAsDataUrl(url) {
		return new Promise((resolve, reject) => {
			const img = new Image();
			img.crossOrigin = 'Anonymous';
			img.onload = () => {
				let canvas = document.createElement('canvas');
				canvas.width = img.width;
				canvas.height = img.height;

				const ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0);

				const dataURL = canvas.toDataURL('image/png');
				resolve(dataURL);
			};
			img.onerror = reject;
			img.src = url;
			if (img.complete || img.complete === undefined) {
				img.src =
					'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
				img.src = url;
			}
		});
	}

	ngOnInit(): void {
		this.loading = true;

		const spUser = localStorage.getItem('sp-user');

		let locale = ''

		this.userService.getSelfUserOp().subscribe((user) => {
			const attr = user?.UserAttributes

			if (attr) {
				for (let i = 0; i < attr.length; i++) {
					if (attr[i].Name === 'locale') {
						locale = attr[i].Value

						if (locale == '5d88a7f3-822b-48da-b4cd-5319f735a531'){
							this.center = { lat: -12.979847270924711, lng: -38.42771955581967 };
							}

						break
					}
				}
			}

			// if (locale && locale == '5d88a7f3-822b-48da-b4cd-5319f735a531'){
			// 	this.center = { lat: -12.979847270924711, lng: -38.42771955581967 };
			// }
		});

		if (spUser === null) {
			this.userService.getSelfUserOp().subscribe((user) => {
				const locale = user.UserAttributes.find(
					(attr) => attr.Name === 'locale'
				).Value;

				if (locale == 'e1a0c005-8a02-4930-b8af-f8a77c2524ed') {
					localStorage.setItem('sp-user', 'true');

					this.center = { lat: -23.55617195585249, lng: -46.63761818550684 };
				} else {
					localStorage.setItem('sp-user', 'false');
				}
			});
		} else {
			if (spUser === 'true') {
				this.center = { lat: -23.55617195585249, lng: -46.63761818550684 };
			}
		}

		this.searchFilter = new FormGroup({
			typeComplaint: new FormControl(['Todos']),
			busLine: new FormControl(),
			ocurrenceDate: new FormControl(),
			placeComplaint: new FormControl(),
			sublocalityComplaint: new FormControl(),
			genderComplaint: new FormControl(),
			age: new FormControl(),
		});


		this.getDashboardCards();

		this.dashService.getComplaintsDashboard().subscribe((res: any) => {
			this.res = res;
			this.checkinPercentage =
				res.check_in_percentages.with_check_in_percentage;
			this.complaints = res.filtered_complaints;
			this.casosAposOcorridos = res.category_counts.moment['Após o ocorrido'];
			this.casosMomentoOcorridos =
				res.category_counts.moment['Durante o ocorrido'];
			this.ocorrenciasFiltradas = res.filtered_complaints;
			this.ocorrenciasFiltradas = this.ocorrenciasFiltradas;
			this.ocorrenciasFiltradas.forEach((element, index) => {
				let type = [];
				element.type.forEach((types, index) => {
					if (index < 2) type.push(types);
					if (index == 2) type.push('...');
				});
				this.ocorrenciasFiltradas[index].type = type;
			});

			this.rankings = {};
			const rankingsData = res.rankings;

			for (const key in rankingsData) {
				const sortedArray = [];

				for (const itemKey in rankingsData[key]) {
					sortedArray.push({
						name: itemKey,
						value: rankingsData[key][itemKey],
					});
				}

				sortedArray.sort((a, b) => b.value - a.value);
				this.rankings[key] = sortedArray;
			}

			this.setMap();
			this.setDefaultValues();
			setTimeout(() => {
				this.loading = false;
			}, 5000);
		});

		this.sse.getSse();
		this.sse$ = this.sse.list$;
		this.sse$.subscribe((event) => {
			let translatedElement = event.shift();

			if (translatedElement && translatedElement.place !== 'BUS') {
				event.push(translatedElement);

				this.store.dispatch(fromComplaintsActions.loadComplaints());
			}
		});
		this.complaints$ = this.store.pipe(
			select(fromComplaintsSelector.selectComplaintsEntities)
		);

		navigator.geolocation.getCurrentPosition((location) => {
			this.center = {
				lat: location.coords.latitude,
				lng: location.coords.longitude,
			};
		});

		this.loading$ = this.store.pipe(
			select(fromComplaintsSelector.selectLoading)
		);

		this.complaints$.subscribe((complaints) => {
			if (complaints.length >= 0) {
				this.getComplaints();
				this.countWeekCases();
			}
		});
	}

	openDialogShowGraphs(): void {
		this.dialog.open(DialogShowGraphs, {
			data: { elementsNav: this.elementsNavGraphs },
		});
	}

	translateType(type: string): string {
		if (type === 'OTHERS') {
			return 'Outros';
		} else if (type === 'SELF_TOUCH_OR_FLASHING') {
			return 'Se tocou ou mostrou';
		} else if (type === 'GROPING') {
			return 'Encoxar/Apalpar';
		} else if (type === 'STALKING') {
			return 'Perseguição';
		} else if (type === 'COERCION') {
			return 'Intimidação';
		} else if (type === 'UNWANTED_PHOTOS') {
			return 'Foto não autorizada';
		} else if (type === "VERBAL_HARASSMENT") {
			return "Agressão Verbal";
		} else if (type === "PHYSICAL_AGGRESSION") {
			return "Agressão Física";
		} else if (type === "FORCED_KISS") {
			return "Beijo Forçado / Violentaram / Tentaram violentar";
		} else {
			return type;
		}
	}

	setDefaultValues(): void {
		this.searchFilter!.controls['typeComplaint']!.setValue('Todos');
		this.searchFilter!.controls['busLine']!.setValue('Todos');
		this.searchFilter!.controls['placeComplaint']!.setValue('Todos');
		this.searchFilter!.controls['sublocalityComplaint']!.setValue('Todos');
		this.searchFilter!.controls['ocurrenceDate']!.setValue('Todos');
		this.searchFilter!.controls['genderComplaint']!.setValue('Todos');
		this.searchFilter!.controls['age']!.setValue('Todos');
		this.created_at_from_date_complaint = null;
		this.created_at_to_date_complaint = null;
	}

	selectedFilters = [];

	removeFilter(filter): void {
		let index = this.selectedFilters.findIndex((f) => f.name == filter.name);

		this.selectedFilters.splice(index, 1);
		this.searchFilter.controls[filter.filter].setValue('Todos');

		this.getComplaintsRecurrent();
	}

	getComplaintsRecurrent(): void {
		this.selectedFilters = [];

		this.showFilters = false;
		this.loading = true;

		const busLine = this.searchFilter.controls['busLine'].value;
		const typeComplaintForm = this.searchFilter.controls['typeComplaint'].value;
		const placeComplaintForm =
			this.searchFilter.controls['placeComplaint'].value;
		const sublocalityComplaintForm =
			this.searchFilter.controls['sublocalityComplaint'].value;
		const genderComplaintForm =
			this.searchFilter.controls['genderComplaint'].value;
		const ageForm = this.searchFilter.controls['age'].value;

		const translationDict = {
			WOMAN_TRANS: 'Mulher trans',
			WOMAN_CIS: 'Mulher cis',
			MAN_TRANS: 'Homem trans',
			MAN_CIS: 'Homem cis',
			NON_BINARY: 'Não binário',
		};

		if (busLine && busLine != 'Todos')
			this.selectedFilters.push({ name: busLine, filter: 'busLine' });
		if (typeComplaintForm && typeComplaintForm != 'Todos')
			this.selectedFilters.push({
				name: typeComplaintForm,
				filter: 'typeComplaint',
			});
		if (placeComplaintForm && placeComplaintForm != 'Todos')
			this.selectedFilters.push({
				name: placeComplaintForm,
				filter: 'placeComplaint',
			});
		if (sublocalityComplaintForm && sublocalityComplaintForm != 'Todos')
			this.selectedFilters.push({
				name: sublocalityComplaintForm,
				filter: 'sublocalityComplaint',
			});
		if (genderComplaintForm && genderComplaintForm != 'Todos')
			this.selectedFilters.push({
				name: translationDict[genderComplaintForm],
				filter: 'genderComplaint',
			});
		if (ageForm && ageForm != 'Todos')
			this.selectedFilters.push({ name: ageForm, filter: 'age' });

		let translatedType: string = typeComplaintDict[typeComplaintForm];
		let translatedPlace: string = placeComplaintDict[placeComplaintForm];

		this.dashService
			.getComplaintsDashboard({
				bus_name: busLine,
				type: translatedType,
				gender: genderComplaintForm,
				place_complaint: translatedPlace,
				sublocality_complaint: sublocalityComplaintForm,
				user_id_complaint: this.user_id_complaint,
				created_at_from_date_complaint: this.created_at_from_date_complaint
					? convertToPythonDatetime(this.created_at_from_date_complaint)
					: null,
				created_at_to_date_complaint: this.created_at_to_date_complaint
					? convertToPythonDatetime(this.created_at_to_date_complaint)
					: null,
				age: ageForm,
			})
			.subscribe((complaints) => {
				this.res = complaints;
				this.casosAposOcorridos =
					complaints.category_counts.moment['Após o ocorrido'];
				this.casosMomentoOcorridos =
					complaints.category_counts.moment['Durante o ocorrido'];
				this.ocorrenciasFiltradas = complaints.filtered_complaints;
				this.ocorrenciasFiltradas = this.ocorrenciasFiltradas;
				this.ocorrenciasFiltradas.forEach((element, index) => {
					let type = [];
					element.type.forEach((types, index) => {
						if (index < 2) type.push(types);
						if (index == 2) type.push('...');
					});
					this.ocorrenciasFiltradas[index].type = type;
				});

				this.rankings = {};
				const rankingsData = complaints.rankings;

				for (const key in rankingsData) {
					const sortedArray = [];

					for (const itemKey in rankingsData[key]) {
						sortedArray.push({
							name: itemKey,
							value: rankingsData[key][itemKey],
						});
					}

					sortedArray.sort((a, b) => b.value - a.value);
					this.rankings[key] = sortedArray;
				}

				this.setMap()

				setTimeout(() => {
					this.loading = false;
				}, 5000);
			});
	}

	buttonsFilter(time): void {
		this.loading = true;
		const busLine = this.searchFilter.controls['busLine'].value;
		const typeComplaintForm = this.searchFilter.controls['typeComplaint'].value;
		const placeComplaintForm =
			this.searchFilter.controls['placeComplaint'].value;
		const sublocalityComplaintForm =
			this.searchFilter.controls['sublocalityComplaint'].value;
		const genderComplaintForm =
			this.searchFilter.controls['genderComplaint'].value;
		const ageForm = this.searchFilter.controls['age'].value;

		let translatedType: string = typeComplaintDict[typeComplaintForm];
		let translatedPlace: string = placeComplaintDict[placeComplaintForm];

		let dataAtual = new Date();
		let dataAnterior = new Date(dataAtual);

		dataAnterior.setDate(dataAtual.getDate() - time);

		this.dashService
			.getComplaintsDashboard({
				bus_name: busLine,
				type: translatedType,
				gender: genderComplaintForm,
				place_complaint: translatedPlace,
				sublocality_complaint: sublocalityComplaintForm,
				user_id_complaint: this.user_id_complaint,
				created_at_from_date_complaint: this.created_at_from_date_complaint
					? convertToPythonDatetime(this.created_at_from_date_complaint)
					: null,
				created_at_to_date_complaint: this.created_at_to_date_complaint
					? convertToPythonDatetime(this.created_at_to_date_complaint)
					: null,
				age: ageForm,
			})
			.subscribe((complaints) => {
				this.res = complaints;
				this.casosAposOcorridos =
					complaints.category_counts.moment['Após o ocorrido'];
				this.casosMomentoOcorridos =
					complaints.category_counts.moment['Durante o ocorrido'];
				this.ocorrenciasFiltradas = complaints.filtered_complaints;
				this.ocorrenciasFiltradas = this.ocorrenciasFiltradas;
				this.ocorrenciasFiltradas.forEach((element, index) => {
					let type = [];
					element.type.forEach((types, index) => {
						if (index < 2) type.push(types);
						if (index == 2) type.push('...');
					});
					this.ocorrenciasFiltradas[index].type = type;
				});

				this.rankings = {};
				const rankingsData = complaints.rankings;

				for (const key in rankingsData) {
					const sortedArray = [];

					for (const itemKey in rankingsData[key]) {
						sortedArray.push({
							name: itemKey,
							value: rankingsData[key][itemKey],
						});
					}

					sortedArray.sort((a, b) => b.value - a.value);
					this.rankings[key] = sortedArray;
				}

				this.setMap();
				setTimeout(() => {
					this.loading = false;
				}, 5000);
			});
	}

	activeNavGraph(e) {
		document
			.querySelector('.active-nav-graph')
			?.classList.toggle('active-nav-graph');
		if (e) this.navGrapActive = e.currentTarget.id;
		document
			.querySelector('#' + this.navGrapActive)
			.classList.toggle('active-nav-graph');
		this.activeGraph();
	}

	activeGraph() {
		document.querySelector('.active-graph')?.classList.toggle('active-graph');
		document
			.querySelector('.' + this.navGrapActive)
			?.classList.toggle('active-graph');
	}

	retirarEspacos(str: string): string {
		return str.replace(/\s/g, '');
	}

	openInformationEvent(e) {
		let versionClicked = e.currentTarget.classList[2];
		let elements = document.querySelectorAll(`.${versionClicked}`);
		elements[2]?.classList.toggle('show');
		elements[1]?.classList.toggle('rotate');
		elements[0]?.classList.toggle('expand-filter');
	}

	/**
	 * Função para receber todos os registros do banco
	 * @param from data de inicio
	 * @param to data de fim
	 */
	public getComplaints(from?: number | Date, to?: number | Date): void {
		this.loading = true;

		let complaints: any[];

		this.complaints$.subscribe((complaintList) => {
			complaints = complaintList;

			if (from && to) {
				this.markers = [];
				if (complaints && complaints.length)
					this.complaints = complaints.filter(
						(denounce: { datetime: string | number | Date }) => {
							return (
								new Date(denounce.datetime) >= from &&
								new Date(denounce.datetime) <= to
							);
						}
					);
			} else {
				this.complaints = complaintList;
			}
		});
		this.setMarkers();
	}

	public setMap(): void {
		this.loading = true;
		this.setMarkers();

		this.mapsAPILoader.load().then(() => {
			this.map = new google.maps.Map(
				document.getElementById('map') as HTMLElement,
				{
					zoom: 13,
					center: this.center,
					mapTypeControl: false,
				}
			);

			this.createDoubleButton();

			setTimeout(() => {
				const markers = this.markers.map((marker) => {
					return new google.maps.Marker({
						position: { lat: marker.lat, lng: marker.lng },
						map: this.map,
						title: 'Custom Marker Title',
						icon: {
							url: './../../assets/images/pin.png',
							scaledSize: new google.maps.Size(0, 0),
						},
					});
				});

				let clusterMap = new MarkerClusterer(this.map, markers, {
					styles: [
						// Aqui, você pode definir vários estilos para diferentes tamanhos de cluster.
						{
							textColor: 'white',
							url: '../../assets/images/cluster_pequeno.png',
							height: 20,
							width: 20,
							textSize: 6,
							fontFamily: 'Roboto',
							anchorText: [0, 0],
							anchorIcon: [40, 0],
						},
						{
							textColor: 'white',
							url: '../../assets/images/cluster_medio.png',
							height: 40,
							width: 40,
							textSize: 15,
							fontFamily: 'Roboto',
							anchorText: [0, 0],
							anchorIcon: [40, 0],
						},
						{
							textColor: 'white',
							url: '../../assets/images/cluster_grande.png',
							height: 80,
							width: 80,
							textSize: 25,
							fontFamily: 'Roboto',
							anchorText: [0, 0],
							anchorIcon: [40, 0],
						},
						// Adicione mais estilos conforme necessário.
					],
				});
			});
		});

		this.loading = false;
	}

	public setHeatMap(): void {
		this.setMarkersHeatMap();

		this.mapsAPILoader.load().then(() => {
			this.map = new google.maps.Map(
				document.getElementById('map') as HTMLElement,
				{
					zoom: 13,
					center: this.center,
					mapTypeControl: false,
				}
			);

			this.createDoubleButton(true);

			setTimeout(() => {
				this.heatmap = new google.maps.visualization.HeatmapLayer({
					data: this.markers,
					map: this.map,
					maxIntensity: 3,
					radius: 20,
					gradient: [
						'rgba(0, 255, 255, 0)',
						'#5948f0',
						'#968cf5',
						'#75b6eb',
						'#21eda6',
						'#21ed7d',
						'#f2f763',
						'#fae06b',
						'#fac16b',
						'#f05e29',
						'#ff3c26',
					],
				});
			});
		});
		setTimeout(() => {
			this.loading = false;
		});
	}

	private setMarkersHeatMap() {
		this.markers = [];

		const isArray = Array.isArray(this.complaints);

		let markerComplaints = this.complaints
		if (!isArray) {
			markerComplaints = this.ocorrenciasFiltradas || (this.complaints as any).complaints;
		}

		markerComplaints.forEach((complaint: any) => {
			this.denounces.push(complaint);
			this.markers.push(
				new google.maps.LatLng(
					complaint.address_coordinates.coordinates[0],
					complaint.address_coordinates.coordinates[1]
				)
			);
		});
	}

	private setMarkers() {
		this.markers = [];
		if (!this.complaints || this.complaints.length == 0) return;

		const isArray = Array.isArray(this.complaints);

		let markerComplaints = this.complaints
		if (!isArray) {
			markerComplaints = this.ocorrenciasFiltradas || (this.complaints as any).complaints;
		}

		markerComplaints?.forEach((complaint: any) => {
			this.denounces.push(complaint);
			this.markers.push({
				lat: complaint.address_coordinates.coordinates[0],
				lng: complaint.address_coordinates.coordinates[1],
			});
		});
	}

	private createDoubleButton(heatmap?: boolean) {
		const container = document.createElement('div');
		container.style.display = 'flex';
		container.style.backgroundColor = '#190262';
		container.style.borderRadius = '16px';

		container.style.margin = '1rem';
		container.style.padding = '.5rem';
		container.style.gap = '.5rem';

		const button1 = this.createButton('Mapa de Calor');
		const button2 = this.createButton('Mapa de Cluster');

		if (!heatmap) {
			button2.classList.add('active');

			button2.style.background = '#fff';
			button2.style.color = '#180064';
		} else {
			button1.classList.add('active');

			button1.style.background = '#fff';
			button1.style.color = '#180064';
		}

		button1.addEventListener('click', () => {
			if (!button1.classList.contains('active')) {
				button1.classList.toggle('active');
			}
			button2.classList.remove('active');

			button1.style.background = '#fff';
			button1.style.color = '#180064';

			if (button1.classList.contains('active')) {
				this.setHeatMap();
			}
		});

		button2.addEventListener('click', () => {
			if (!button2.classList.contains('active')) {
				button2.classList.toggle('active');
			}
			button1.classList.remove('active');

			button2.style.background = '#fff';
			button2.style.color = '#180064';

			if (button2.classList.contains('active')) {
				this.setMap();
			}
		});

		container.appendChild(button1);
		container.appendChild(button2);

		this.map.controls[google.maps.ControlPosition.BOTTOM_RIGHT].push(container);
	}

	openDatePicker() {
		const datePickerInput = document.getElementById(
			'picker-toggle'
		) as HTMLInputElement;

		if (datePickerInput) {
			datePickerInput.click();
		}
	}

	private createButton(buttonTitle) {
		let controlButton = document.createElement('button');

		controlButton.style.display = 'flex';
		controlButton.style.alignItems = 'center';
		controlButton.style.justifyContent = 'center';
		controlButton.style.border = 'none';
		controlButton.style.borderRadius = '16px';
		controlButton.style.padding = '0.25rem 1rem';
		controlButton.style.background = '#180064';
		controlButton.style.color = '#fff';
		controlButton.style.fontSize = '0.875rem';
		controlButton.style.fontWeight = '700';
		controlButton.style.transition = 'all 0.2s ease-in-out';

		controlButton.addEventListener('mouseover', () => {
			controlButton.style.background = '#fff';
			controlButton.style.color = '#180064';
		});

		controlButton.addEventListener('mouseout', () => {
			if (!controlButton.classList.contains('active')) {
				controlButton.style.background = '#180064';
				controlButton.style.color = '#fff';
			}
		});

		controlButton.textContent = buttonTitle;

		return controlButton;
	}

	public countWeekCases(): void {
		this.dashService.getWeekComplaints().subscribe((res: any) => {
			this.weekData = res;
			const lastWeekData = res.week_before;

			this.imagePercent =
				lastWeekData.media_amount === 0
					? 0
					: (this.weekData.media_amount - lastWeekData.media_amount) /
					  lastWeekData.media_amount;

			this.imagePercent = parseFloat(this.imagePercent.toFixed(2));

			this.casesPercent =
				lastWeekData.week_count === 0
					? 0
					: (this.weekData.week_count - lastWeekData.week_count) /
					  lastWeekData.week_count;

			this.completedPercent =
				lastWeekData.completed === 0
					? 0
					: (this.weekData.completed - lastWeekData.completed) /
					  lastWeekData.completed;

			this.completedPercent = isNaN(this.completedPercent)
				? 0
				: (this.completedPercent * 100).toFixed(0);

			this.casesPercent = isNaN(this.casesPercent)
				? 0
				: (this.casesPercent * 100).toFixed(0);

			if (this.weekData.week_count > 0) {
				this.weekData.completedPercent =
					this.weekData.completed / this.weekData.week_count;
			} else {
				this.weekData.completedPercent = 0;
			}

			if (lastWeekData.week_count > 0) {
				lastWeekData.completedPercent =
					lastWeekData.completed / lastWeekData.week_count;
			} else {
				lastWeekData.completedPercent = 0;
			}
		});
	}

	staticInfoLoading = false;

	public getDashboardCards(): void {
		this.staticInfoLoading = true;
		this.dashService.getDashboardCards().subscribe((res: any) => {
			this.dashboardCardsData = res;
			this.staticInfoLoading = false;

			this.sublocalities = res.distinct_values?.sublocality;
		});
	}

	public dateFilterOp(days: any): any {
		this.loading = true;
		this.lastWeek = new Date();
		this.lastWeek.setDate(this.lastWeek.getDate() - 7);
		this.lastTwoWeeks = new Date(this.lastWeek);
		this.lastTwoWeeks.setDate(this.lastTwoWeeks.getDate() - 7);

		if (days === '7') {
			this.from = new Date(
				this.lastWeek.getFullYear(),
				this.lastWeek.getMonth(),
				this.lastWeek.getDate(),
				0,
				0,
				0
			);

			this.complaints = null;
			this.denounces = [];
			this.markers = [];
			this.to = new Date();

			this.getComplaints(this.from, this.to);
			this.barChartLabels = [`Ultimos 7 dias`];
			this.clearDatepicker();
		} else if (days === '15') {
			this.from = new Date(
				this.lastTwoWeeks.getFullYear(),
				this.lastTwoWeeks.getMonth(),
				this.lastTwoWeeks.getDate(),
				0,
				0,
				0
			);

			this.barChartLabels = [`Ultimos 15 dias`];
			this.complaints = null;
			this.denounces = [];
			this.markers = [];
			this.to = new Date();
			this.getComplaints(this.from, this.to);
			this.clearDatepicker();
		} else {
			this.from = null;
			this.complaints = null;
			this.denounces = [];
			this.markers = [];
			this.barChartLabels = [`Todos os dias`];
			this.to = null;
			this.getComplaints();
			this.clearDatepicker();
		}

		this.setMap();
	}

	/**
	 * Função responsável por receber o valor inicial do calendário no dashboard
	 * @param event Valor recebido pelo calendário no dashboard
	 */
	public onInitialDateChange(event: MatDatepickerInputEvent<Date>): void {
		this.initialDate = event.value;
		this.created_at_from_date_complaint = this.initialDate;
		this.barChartLabels = [
			`${this.formatarDataBrasileira(
				this.initialDate
			)} - ${this.formatarDataBrasileira(this.endDate)}`,
		];
		this.selectedLabel = this.barChartLabels[0];
	}

	/**
	 * Função responsável por receber o segundo valor do calendário no dashboard
	 * @param event Valor recebido pelo calendário no dashboard
	 */
	public onEndDateChange(event: MatDatepickerInputEvent<Date>): void {
		this.endDate = event.value;
		this.created_at_to_date_complaint = this.endDate;
		this.barChartLabels = [
			`${this.formatarDataBrasileira(
				this.initialDate
			)} - ${this.formatarDataBrasileira(this.endDate)}`,
		];
		this.selectedLabel = this.barChartLabels[0];

		if (this.initialDate != null && this.endDate != null) {
			this.from = new Date(
				this.initialDate.getFullYear(),
				this.initialDate.getMonth(),
				this.initialDate.getDate(),
				0,
				0,
				0
			);
			this.to = new Date(
				this.endDate.getFullYear(),
				this.endDate.getMonth(),
				this.endDate.getDate(),
				0,
				0,
				0
			);
			this.complaints = null;
			this.denounces = [];
			this.markers = [];
			this.getComplaints(this.from, this.to);

			this.setMap();
		}
	}

	/**
	 * Função para checar qual a cor será utilizada no card do dashboard
	 * @param value valor do cálculo entre as semanas
	 * @returns booleano para saber qual a cor será usada indicando queda ou aumento do valor em relação a semana anterior
	 */
	public checkSign(value: number): boolean {
		if (Math.sign(value) === -1) {
			return false;
		} else {
			return true;
		}
	}

	/**
	 * Função para checar qual seta será utilizada no card do dashboard
	 * @param value valor do cálculo entre as semanas
	 * @returns booleano para saber qual a seta será usada indicando queda ou aumento do valor em relação a semana anterior
	 */
	public setArrow(value: number): string {
		if (this.checkSign(value)) {
			return 'trending_up';
		} else {
			return 'trending_down';
		}
	}

	formatarDataBrasileira(data) {
		if (data) {
			const dia = String(data.getDate()).padStart(2, '0');
			const mes = String(data.getMonth() + 1).padStart(2, '0');
			const ano = String(data.getFullYear()).slice(2);
			return `${dia}/${mes}/${ano}`;
		} else {
			return '';
		}
	}

	today = new Date();
	formatDate(dateStr) {
		const date = new Date(dateStr);
		const day = date.getDate().toString().padStart(2, '0');
		const month = (date.getMonth() + 1).toString().padStart(2, '0');
		const year = date.getFullYear();
		return `${day}/${month}/${year}`;
	}

	clearDatepicker() {
		this.dateRangePicker.close();
		this.selectedLabel = 'Todos';
	}

	cleanDate() {
		this.initialDate = null;
		this.created_at_from_date_complaint = null;
		this.endDate = null;
		this.created_at_to_date_complaint = null;
		this.selectedLabel = 'Todos';
		this.getComplaintsRecurrent();
	}
}

@Component({
	selector: 'dialog-overview-example-dialog',
	templateUrl: 'dialog-overview-example-dialog.html',
})
export class DialogShowGraphs {
	constructor(
		public dialogRef: MatDialogRef<DialogShowGraphs>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	retirarEspacos(str: string): string {
		return str.replace(/\s/g, '');
	}

	onNoClick(): void {
		this.dialogRef.close();
	}
	items = this.data.elementsNav;
	dragStartIndex: number;

	onDragStart(index: number) {
		this.dragStartIndex = index;
	}

	onDragOver(event: DragEvent) {
		event.preventDefault();
	}

	onDrop(index: number) {
		this.swapItems(this.dragStartIndex, index);
	}

	private swapItems(fromIndex: number, toIndex: number) {
		const temp = this.items[fromIndex];
		this.items[fromIndex] = this.items[toIndex];
		this.items[toIndex] = temp;
	}
}

function convertToPythonDatetime(date) {
	const year = date.getFullYear();
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const day = date.getDate().toString().padStart(2, '0');
	const hours = date.getHours().toString().padStart(2, '0');
	const minutes = date.getMinutes().toString().padStart(2, '0');
	const seconds = date.getSeconds().toString().padStart(2, '0');

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
